import { useState, useEffect, useRef } from "react";
import { createModel } from "hox";
import { enquiryService } from "../../drodService";
import { IDrodTabEnum, ISupplierPriceDialog, IDrodMaterialDetail, IDrodDetail, ISupplierOfferDetails, ISupplierMaterialDetails } from "../../drodTypes";
import { IMaterialDetail } from "@/views/base/material/materialService";
import { message } from "antd";
import useGlobalModel from "@/model/globalModel";
import { useLockFn } from "ahooks";
import { convertRes2Blob } from "@/utils/exportFile";
import moment from "moment";


export const useDrodDetailModel = createModel(function () {
    const { user: { shopCode, shopName }, setLoadingInfo } = useGlobalModel(({ user }) => [user])
    const initFormVal = {
        id: "",
        code: "",
        shopName
    } as IDrodDetail;
    const [tabActive, setTabActive] = useState<IDrodTabEnum>(IDrodTabEnum.BASE_DETAIL) //tabs 选中

    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<IDrodDetail>(initFormVal);
    const [editList, setEditList] = useState<IDrodMaterialDetail[]>([]);

    //新增缓存
    const [addFormVal, setAddFormVal] = useState<IDrodDetail>(initFormVal);
    const [addList, setAddList] = useState<IDrodMaterialDetail[]>([]);

    //添加商品弹框
    const [materialDialog, setMaterialDialog] = useState<boolean>(false);

    //重置页面缓存
    const resetPageCache = (mode: string) => {
        if (mode === "edit") {
            setEditFormVal(initFormVal);
            setEditList([]);
        }
        else if (mode === "add") {
            setAddFormVal(initFormVal);
            setAddList([]);
        }
        setTabActive(IDrodTabEnum.BASE_DETAIL);
    }

    //主单修改
    const updateFormVal = (mode: string, val?: object | null) => {
        const setFormVal = mode === "edit" ? setEditFormVal : setAddFormVal;
        setFormVal((origin: any) => val ? { ...origin, ...val } : initFormVal);
    }

    //商品子表修改
    const updateList = (mode: string, val: IDrodMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList([...val]);
    }

    //获取一条数据
    const getDrodDetailOne = async (id: string) => {
        let { retData } = await enquiryService.one(id);
        if (retData) {
            setEditFormVal({
                ...retData,
                createTime: retData.createTime ? moment(retData.createTime): "",
                updateTime: retData.updateTime ? moment(retData.updateTime) : "",
                drawbackTime:retData.drawbackTime ? moment(retData.drawbackTime) : "",
            });
        }
        return retData;
    };

    //报价单新增 | 编辑
    const insertOrUpdateDrod = useLockFn(async (mode: string, formVal: IDrodDetail = editFormVal, isMessage = true) => {       
        let data = {
            ...formVal,
            ...editFormVal,
            //createTime: formVal?.createTime instanceof ? moment(formVal.createTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
            //updateTime: formVal?.updateTime ? moment(formVal.updateTime).format('YYYY-MM-DD HH:mm:ss') : undefined,
            createTime: formVal.createTime instanceof Object ? formVal.createTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            updateTime:formVal?.updateTime ? moment(formVal.updateTime).format('YYYY-MM-DDTHH:mm:ss') : undefined,
            drawbackTime: editFormVal?.drawbackTime  instanceof Object ? editFormVal.drawbackTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            //drawbackTime:"2022-05-23T15:23:34",
            shopCode,
            shopName,
        };
        //新增
        if (mode === "edit") {
            //取消updateUser传值给后端
            delete data.updateUser
            let { retData } = await enquiryService.update({ ...data, id: editFormVal.id, code: editFormVal.code ?? "" });
            isMessage && getDrodDetailOne(editFormVal.id)
            isMessage && message.success("保存成功")
            return retData;
        } else {
            let { retData } = await enquiryService.insert(data);
            message.success("新增成功,自动转换至编辑详情页")
            return retData;
        }
    })

    //导出
    const exportDrod = async () => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" });
        try {
            let result = await enquiryService.detailExport(editFormVal.code, shopCode);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch { setLoadingInfo({ loadingVisible: false, txt: "" }) }
    }

    //报价单明细下载模板
    const downloadTpl = async () => {
        let result = await enquiryService.downloadTpl();
        convertRes2Blob(result);
    }
    //提交退税
    const submit = async () => {
        let result = await enquiryService.submit(editFormVal.code);
        message.success("提交退税成功");
        getDrodDetailOne(editFormVal.id)
    }
    //报价单明细下载模板
    const drawback = async () => {
        let result = await enquiryService.drawback(editFormVal.code);
        message.success("退税成功");
        getDrodDetailOne(editFormVal.id)
    }

    return {
        /***field***/
        editFormVal,
        editList,
        addFormVal,
        addList,
        tabActive, setTabActive,
        materialDialog, setMaterialDialog,
        /***method***/
        getDrodDetailOne,
        updateFormVal,
        updateList,
        insertOrUpdateDrod,
        resetPageCache,
        exportDrod,
        downloadTpl, submit, drawback
    }
});